import "core-js/modules/es.array.index-of";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(requireMembershipSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { select, call } from 'redux-saga/effects';
import { isLoggedIn } from 'redux/saga/selectors';
import { userProfile } from 'redux/saga/entities/bound';
export default function requireMembershipSaga(client, replaceState, validStatuses) {
  var profile, status;
  return regeneratorRuntime.wrap(function requireMembershipSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(isLoggedIn);

        case 2:
          if (!_context.sent) {
            _context.next = 11;
            break;
          }

          _context.next = 5;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 5:
          profile = _context.sent;
          status = profile.membership.status;

          if (!(validStatuses.indexOf(status) === -1)) {
            _context.next = 11;
            break;
          }

          _context.next = 10;
          return call(replaceState, '/');

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}